const ACCESS = [["public", "Public (anyone)"], ["free", "Free members"], ["premium", "Premium"], ["coaching", "Coaching"]];
const SEO = [
  { k: "seo_title", label: "SEO title", type: "text" },
  { k: "meta_description", label: "Meta description", type: "textarea" },
];

export const SCHEMAS = {
  videos: {
    label: "Videos", columns: ["title", "category", "access"],
    fields: [
      { k: "title", label: "Title", type: "text", required: true },
      { k: "slug", label: "URL slug (auto if empty)", type: "text" },
      { k: "category", label: "Category / Series", type: "category" },
      { k: "access", label: "Access", type: "select", options: ACCESS },
      { k: "video_url", label: "Video URL (YouTube, Vimeo, embed or MP4)", type: "text" },
      { k: "thumbnail", label: "Thumbnail", type: "image" },
      { k: "duration", label: "Duration (e.g. 24:10)", type: "text" },
      { k: "description", label: "Description", type: "textarea" },
      { k: "attachments", label: "Downloadable resources", type: "attachments" },
      { k: "order", label: "Sort order", type: "number" },
      { k: "featured", label: "Featured on homepage", type: "bool" },
      { k: "is_demo", label: "Show DEMO label", type: "bool" },
      ...SEO,
      { k: "published", label: "Published", type: "bool" },
    ],
  },
  courses: {
    label: "Courses", columns: ["title", "access", "price"],
    fields: [
      { k: "title", label: "Title", type: "text", required: true },
      { k: "slug", label: "URL slug", type: "text" },
      { k: "access", label: "Enrollment access", type: "select", options: [...ACCESS.slice(1), ["paid", "One-time purchase"]] },
      { k: "price", label: "Price USD (one-time purchase only)", type: "number" },
      { k: "cover_image", label: "Cover image", type: "image" },
      { k: "level", label: "Level", type: "text" },
      { k: "description", label: "Description", type: "textarea" },
      { k: "modules", label: "Modules & lessons", type: "modules" },
      { k: "is_demo", label: "Show DEMO label", type: "bool" },
      ...SEO,
      { k: "published", label: "Published", type: "bool" },
    ],
  },
  posts: {
    label: "Blog posts", columns: ["title", "category", "access"],
    fields: [
      { k: "title", label: "Title", type: "text", required: true },
      { k: "slug", label: "URL slug", type: "text" },
      { k: "category", label: "Category", type: "text" },
      { k: "author", label: "Author", type: "text" },
      { k: "access", label: "Access", type: "select", options: ACCESS },
      { k: "cover_image", label: "Cover image", type: "image" },
      { k: "excerpt", label: "Excerpt", type: "textarea" },
      { k: "body", label: "Body (blank line = new paragraph, start a paragraph with ## for a heading)", type: "textarea", rows: 14 },
      { k: "is_demo", label: "Show DEMO label", type: "bool" },
      ...SEO,
      { k: "published", label: "Published", type: "bool" },
    ],
  },
  events: {
    label: "Events", columns: ["title", "start_date", "event_type"],
    fields: [
      { k: "title", label: "Title", type: "text", required: true },
      { k: "event_type", label: "Type", type: "select", options: [["workshop", "Workshop"], ["conference", "Conference"], ["online", "Online training"], ["live", "Live event"]] },
      { k: "start_date", label: "Date", type: "date" },
      { k: "location", label: "Location", type: "text" },
      { k: "image", label: "Image", type: "image" },
      { k: "description", label: "Description", type: "textarea" },
      { k: "registration_url", label: "Registration URL", type: "text" },
      { k: "is_demo", label: "Show DEMO label", type: "bool" },
      { k: "published", label: "Published", type: "bool" },
    ],
  },
  resources: {
    label: "Resources", columns: ["title", "resource_type", "access"],
    fields: [
      { k: "title", label: "Title", type: "text", required: true },
      { k: "resource_type", label: "Type", type: "select", options: [["worksheet", "Worksheet"], ["study guide", "Study guide"], ["devotional", "Devotional"], ["ebook", "eBook"], ["audio", "Audio"]] },
      { k: "access", label: "Access", type: "select", options: ACCESS },
      { k: "file_url", label: "File", type: "file" },
      { k: "thumbnail", label: "Thumbnail", type: "image" },
      { k: "description", label: "Description", type: "textarea" },
      { k: "is_demo", label: "Show DEMO label", type: "bool" },
      { k: "published", label: "Published", type: "bool" },
    ],
  },
  products: {
    label: "Store products", columns: ["title", "category", "order"],
    fields: [
      { k: "title", label: "Product name", type: "text", required: true },
      { k: "amazon_url", label: "Amazon link", type: "text", required: true },
      { k: "image", label: "Product image", type: "image" },
      { k: "category", label: "Category (e.g. Books, Bibles, Gear)", type: "text" },
      { k: "description", label: "Why Todd recommends it", type: "textarea" },
      { k: "order", label: "Sort order", type: "number" },
      { k: "published", label: "Published", type: "bool" },
    ],
  },
  programs: {
    label: "Coaching programs", columns: ["title", "order"],
    fields: [
      { k: "title", label: "Title", type: "text", required: true },
      { k: "description", label: "Summary", type: "textarea" },
      { k: "details", label: "Details (format, schedule, pricing)", type: "textarea" },
      { k: "image", label: "Image", type: "image" },
      { k: "cta_label", label: "Button label", type: "text" },
      { k: "cta_url", label: "Button link", type: "text" },
      { k: "order", label: "Sort order", type: "number" },
      { k: "published", label: "Published", type: "bool" },
    ],
  },
  landing_pages: {
    label: "Landing pages", columns: ["title", "slug", "template"],
    fields: [
      { k: "title", label: "Internal title", type: "text", required: true },
      { k: "slug", label: "URL slug (/lp/...)", type: "text" },
      { k: "template", label: "Template", type: "select", options: [["course", "Course"], ["coaching", "Coaching program"], ["workshop", "Workshop"], ["offer", "Special offer"]] },
      { k: "headline", label: "Headline", type: "text" },
      { k: "subheadline", label: "Subheadline", type: "textarea" },
      { k: "image", label: "Hero image", type: "image" },
      { k: "body", label: "Body", type: "textarea" },
      { k: "bullets", label: "Highlights (one per line)", type: "lines" },
      { k: "cta_label", label: "Button label", type: "text" },
      { k: "cta_url", label: "Button link", type: "text" },
      ...SEO,
      { k: "published", label: "Published", type: "bool" },
    ],
  },
  testimonials: {
    label: "Testimonials", columns: ["name", "role"],
    fields: [
      { k: "name", label: "Name (real, with permission)", type: "text", required: true },
      { k: "role", label: "Role / location", type: "text" },
      { k: "quote", label: "Quote", type: "textarea" },
      { k: "published", label: "Published", type: "bool" },
    ],
  },
  categories: {
    label: "Video categories", columns: ["name", "order"],
    fields: [
      { k: "name", label: "Name", type: "text", required: true },
      { k: "order", label: "Sort order", type: "number" },
      { k: "published", label: "Published", type: "bool" },
    ],
  },
};
